import React, { useMemo } from 'react';
import cx from 'classnames';
import Checkbox from '../../components/Checkbox';
import Currency from '../../components/Price';
import Input from '../../components/Input';
import Debt from './Debt';
import { INPUT_TYPES } from '../../utils/constants';
import { useStateContext } from '../../context/StateContext';
import { updateOverviewState } from '../../reducers/actions';
import style from './summary-debt-area.module.scss';

const SummaryDebtArea = ({ isFastPay }) => {
	const { state: { overview }, dispatch } = useStateContext();
	const isAllDebtInputChecked = useMemo(() =>
		overview?.overviewDetail?.every(item => item.isChecked), [overview]
	) || false;
	const handleOnCheckboxChange = (item, index, status) => {
		const { overviewDetail } = overview;
		overviewDetail[index].isChecked = status;

		updateOverflowState(overviewDetail);
	};

	const handleOnInputChange = (item, index, value) => {
		const { overviewDetail } = overview;
		overviewDetail[index].paymentPrice = parseFloat(value);

		updateOverflowState(overviewDetail);
	};

	const handleOnAllDebtInputChange = status => {
		const { overviewDetail } = overview;
		overviewDetail?.forEach(item => item.isChecked = status);

		updateOverflowState(overviewDetail);
	};

	const updateOverflowState = data => {
		const totalPaymentPrice = data
			?.filter(item => item?.isChecked)
			?.reduce((prevValue, nextItem) => prevValue + (nextItem?.paymentPrice || 0), 0);

		updateOverviewState({ payload: {
			...overview,
			totalPaymentPrice,
			overviewDetail: data
		}, dispatch });
	};

	return (
		<table className={cx(style.container, { [style.isFastPay]: isFastPay })}>
			<tbody>
				<tr>
					<th>
						{!isFastPay && overview?.overviewDetail?.length && (
							<Checkbox label='Hepsi' onChange={handleOnAllDebtInputChange} isChecked={isAllDebtInputChecked} />
						)}
					</th>
					<th className={style.debt}>Borç</th>
					<th>Ödenecek tutar</th>
				</tr>
				{
					overview?.overviewDetail?.map((item, index) => (
						<tr key={index}>
							<td>
								<Debt isChecked={item?.isChecked} description={item?.description} onChange={status => handleOnCheckboxChange(item, index, status)} />
							</td>
							<td className={style.debt}>
								<Currency className={style.price} currencyClassName={style.price} value={item?.totalPrice}/>
							</td>
							<td>
								<div className={style.inputContainer}>
									<Input initialValue={item?.paymentPrice} disabled={overview.isFlexible ? false : true} className={style.input} inputType={INPUT_TYPES.CURRENCY} onChange={value => handleOnInputChange(item, index, value)} />
								</div>
							</td>
						</tr>
					))
				}
			</tbody>
		</table>
	);
};

export default SummaryDebtArea;
